module.exports = __webpack_public_path__ + "static/cases-tile-2-3-98714d7487402a78a180cbac120d26ca.png";